"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
exports.GlobalDefaultKeys = {
    UseNewApi: '__WIXEXP_USE_NEW_API',
};
function getValueOrEmptyObject(objectKey, globalValueKey, type) {
    var _a;
    return typeof self !== 'undefined' && typeof self[globalValueKey] === type
        ? (_a = {}, _a[objectKey] = self[globalValueKey], _a) : {};
}
function getGlobalDefaults() {
    return tslib_1.__assign({}, getValueOrEmptyObject('useNewApi', exports.GlobalDefaultKeys.UseNewApi, 'boolean'));
}
exports.getGlobalDefaults = getGlobalDefaults;
//# sourceMappingURL=global-defaults.js.map